"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
interface GalleryImage {
  src: string;
  alt: string;
}
const galleryImages: GalleryImage[] = [{
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0942-scaled.jpg?v=z4tjgy12cr",
  alt: "Ruhiger Behandlungsraum mit Liege und Naturleinen"
}, {
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0943-scaled.jpg?v=054b2n9hbeep",
  alt: "Hände ruhen sanft in der Reiki-Behandlung"
}, {
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0944-scaled.jpg?v=4dy3nblre9p",
  alt: "Kerze und Lavendelblüten auf einem Holztisch"
}, {
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0945-scaled.jpg?v=j64e40vj4mo",
  alt: "Lavendelfeld im weichen Morgenlicht"
}];
export default function ReikiGalerie() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.08,
        delayChildren: 0.05
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 12
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.45,
        ease: "easeOut"
      }
    }
  };
  return <section id="reikigalerie" data-nav="light" className="bg-background text-foreground py-12 md:py-16 border-b border-border/40 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.45,
        ease: "easeOut"
      }} className="mx-auto max-w-2xl text-center space-y-2 mb-8 md:mb-10">
          
          
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 max-w-4xl lg:max-w-5xl mx-auto">
          {galleryImages.map((image, index) => <motion.div key={image.src} variants={itemVariants} data-index={index} className="group relative overflow-hidden rounded-xl border border-border/70 bg-card shadow-xs transition-shadow duration-300 hover:shadow-md">
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted">
                <img src={image.src} alt={image.alt} className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" loading="lazy" />
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}